import { FormProps } from '@deltek/specification-client/core/Models/formProps'
import {
    keyDownHandler,
    RTFController,
} from '@deltek/specification-client/core/Widgets/RTFController'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
    clipBoardHandler,
    overriddenFontStyle,
} from 'bpm/pages/ProductsPage/productsUtils'
import clsx from 'clsx'
import React, { useState } from 'react'
import ContentEditable, { ContentEditableEvent } from 'react-contenteditable'
import { ProductListingDetailFormField } from '../ListingDetailsPage'

const useStyles = makeStyles((theme: Theme) => ({
    container: { paddingTop: theme.spacing(2) },
    inputRoot: {
        borderRadius: 4,
        height: '250px',
        border: '1px solid rgba(0,0,0,0.12)',
        padding: '12px',
        overflow: 'auto',
        overflowWrap: 'anywhere',
        outline: '0px solid transparent',
    },
    font: {
        ...theme.typography.h6,
        whiteSpace: 'pre-wrap',
        //For overriding Browese  user-agent style/auto created style for content editable, style from ms word document etc.
        '& span,& i, & div, & b, & strong, & li, & blockquote, & p, & u': {
            ...overriddenFontStyle,
        },
    },
    error: {
        border: `1px solid ${theme.palette.error.main}`,
    },
}))

interface EditDescriptionProps extends Partial<FormProps> {
    handleFieldChange: (
        field: ProductListingDetailFormField,
        value: string
    ) => void
    editMode?: boolean
}

export const EditDescriptionRTF: React.FC<EditDescriptionProps> = ({
    value,
    valid = true,
    editMode = false,
    handleFieldChange,
}) => {
    const classes = useStyles()

    const rtfHandleChange = (event: ContentEditableEvent) => {
        handleFieldChange('description', event.target.value)
    }
    const [resetState, setResetState] = useState<string>('')
    const contentClasses = [
        (editMode && classes.inputRoot) || '',
        (editMode && !valid && classes.error) || '',
        classes.font,
    ]
    return (
        <div className={classes.container} data-testid="editDescription">
            {editMode && <RTFController resetState={resetState} />}

            <ContentEditable
                html={(value ?? '') as string}
                onChange={rtfHandleChange}
                onPaste={clipBoardHandler}
                onKeyUp={() => setResetState(Date.now().toString())}
                onKeyDown={keyDownHandler}
                onDrop={(ev) => ev.preventDefault()}
                onBlur={() => setResetState('')}
                onClick={() => setResetState(Date.now().toString())}
                className={clsx(...contentClasses)}
                disabled={!editMode}
                data-testid="editableContent"
            />
        </div>
    )
}
